import { render, staticRenderFns } from "./SubjectModal.vue?vue&type=template&id=3ffb370e&scoped=true&"
import script from "./SubjectModal.vue?vue&type=script&lang=js&"
export * from "./SubjectModal.vue?vue&type=script&lang=js&"
import style0 from "./SubjectModal.vue?vue&type=style&index=0&id=3ffb370e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb370e",
  null
  
)

export default component.exports